const navigationsRoute = {
  FORGOT_PASSWORD: '/forgot-password',
  LOGIN_PAGE: '/',
  VERIFIED_EMAIL_SUCCESS: '/verification-email-success',
  IONIC_APP_HOME: '/home/timeline/',
  EASY_LOGIN_BASE_URL: '/easy_login',
  TASKS: '/tasks',
  CALENDAR: '/calendar-mv',
  CALENDAR_MOBILE: '/calendar',
  DAMAGE_PROTECTION: '/damage-protection',
  PAYMENT_PROCESSORS: '/financial/payment-processors',
  VRBO_INTEGRATION: '/vrbo',
  DYNAMIC_PRICING: '/price-optimizer',
  DYNAMIC_PRICING_MANAGER: '/price-optimizer/manage',
  AIRBNB_ONBOARDING: '/airbnb',
  GUESTY_CAPITAL: '/capital',
  SMART_LOCKS: '/guesty-locks-manager',
  ADD_NEW_RESERVATION_PAGE: '/add-new-reservation-page',
  TRIAL_WEB_VIEW: '/trial-web-view',
  MARKUP_RATES: '/markup-rates',
  BOOKING_INTEGRATION: '/bcom',
  ACCOUNT: '/more-menu/settings/profile',
  LOGOUT: '/logout',
} as const;

export default navigationsRoute;
